export function decodeBase64(str: string): string {
  return Buffer.from(str, 'base64').toString('binary')
}

export function encodeBase64(str: string): string {
  return Buffer.from(str, 'binary').toString('base64')
}
